import styled from 'styled-components';
import PropTypes from 'prop-types';
import PageEditor from 'components/PageEditor';
import LizzySidebar from 'components/Sidebar';
import WidgetSwitcher from 'components/WidgetSwitcher';

const PageLayout = ({ editorInitialValue }) => {
  return (
    <Wrapper>
      <PageEditor initialValue={editorInitialValue} />
      <LizzySidebar />
      <WidgetSwitcher />
    </Wrapper>
  );
}

export default PageLayout;

PageLayout.propTypes = {
  editorInitialValue: PropTypes.string,
};

PageLayout.defaultProps = {
  editorInitialValue: '',
};

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;